// extracted by mini-css-extract-plugin
export default {"exam_schedule_board":"exam-schedule-board_exam_schedule_board__-D-hy"};